import i18n from '@/i18n';
import {TreatmentType} from '@/services/graphqlHooks';

const treatmentType = {
  [TreatmentType.Continuous]: i18n.t('Continuous'),
  [TreatmentType.Temporary]: i18n.t('Temporary'),
  [TreatmentType.AsNeeded]: i18n.t('As needed'),
} as Record<TreatmentType, string>;

export default treatmentType;
